import React, { useEffect, useState } from "react";
import { AnyBlock, CssBlock as CssBlockType, User } from "../types";
import { styled } from "../stitches.config";
import { useManagedTextArea } from "./TextBlock";
import { useUserInfo } from "../roomservice/maps";
import { useDebounce } from "../utils/useThrottle";
import { detect } from "detect-browser";

export function defaultCSS(user: User) {
  return `/* Write some css! */
.${user?.name} {
  border-width: 1px;
  border-style: solid;
  border-color: black;
  background-color: ${user?.color};
}

.background {

}`;
}

function CssBlock({
  block,
  updateBlock,
  deleteBlock,
}: {
  block: CssBlockType;
  updateBlock: (block: Partial<AnyBlock>) => void;
  deleteBlock: (blockId: string) => void;
}) {
  const { textAreaRef, onKeyDown, onChange } = useManagedTextArea(
    block,
    updateBlock,
    deleteBlock
  );
  let [user] = useUserInfo(block?.madeBy);
  const [style, setStyle] = useState("");

  function updateStyle(value: string) {
    if (!value) return;
    setStyle(value.replace(/;\n/g, " !important;\n"));
  }

  const updateStyleDebounced = useDebounce(
    updateStyle,
    detect()?.name === "safari" ? 1000 : 0
  );

  useEffect(() => {
    updateStyleDebounced(block.value);
  }, [updateStyleDebounced, block.value]);

  return (
    <Bezel>
      <CodeArea
        spellCheck={false}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onDoubleClick={(e) => {
          textAreaRef.current!.focus();
        }}
        style={{
          cursor:
            document.activeElement === textAreaRef.current ? "text" : "grab",
        }}
        onMouseDown={(e) => {
          // prevent moving/selecting block when it's focused
          if (document.activeElement === e.target) {
            e.stopPropagation();
          }
        }}
        value={block.value}
        placeholder={`// Write some css! \n.block {\n    border: 1px solid pink;\n}

.background {
    background-color: lavender;
}

.${user?.name} {
  border-color: ${user?.color};
}`}
        ref={textAreaRef}
      />
      <style>{style}</style>
    </Bezel>
  );
}

export default CssBlock;

export const Bezel = styled("div", {
  margin: "$2",
  width: "calc(100% - $4)",
  height: "calc(100% - $4)",
  display: "flex",
});

const CodeArea = styled("textarea", {
  width: "100%",
  height: "100%",
  padding: ".5rem",
  resize: "none",
  color: "$brown",
  lineHeight: "$5",
  fontSize: "$4",
  fontFamily: "monospace",
  background: "$grey225",
});
